module.exports = __webpack_public_path__ + "img/SS_V_Gold_FA_Grass.abfe0cc9.png";